import { faBagShopping } from "@jewlr/pro-light-svg-icons/faBagShopping"
import PropTypes from "prop-types"
import { useState } from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

import { emptyCart } from "areas/cart/store/actions"
import Confirmation from "components/ui/confirmation"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { jewlr_t } from "helpers/application"

import { LinkButton } from "./components"

const InternalEmptyOutCart = ({ callEmptyCart }) => {
  const [showEmptyCartDialog, setShowEmptyCartDialog] = useState(false)

  const onCancel = () => {
    setShowEmptyCartDialog(false)
  }

  const onConfirm = () => {
    callEmptyCart()
    setShowEmptyCartDialog(false)
  }

  return (
    <div className="contained mb-24 mt-16 flex flex-col text-center">
      <LinkButton asChild className="mx-auto">
        <Link data-lc="empty-out-cart" to="/">
          Continue Shopping
        </Link>
      </LinkButton>
      <LinkButton
        className="mx-auto mt-16 gap-6"
        onClick={() => setShowEmptyCartDialog(true)}
        text
        underline
        variant="secondary"
      >
        <FontAwesomeIcon icon={faBagShopping} />
        Empty {jewlr_t("Cart")}
      </LinkButton>
      <Confirmation
        cancelText="Cancel"
        confirmText="Yes"
        description={`Are you sure you want to remove all items from your ${jewlr_t(
          "Cart"
        )}?`}
        onCancel={onCancel}
        onConfirm={onConfirm}
        show={showEmptyCartDialog}
        title={`Empty ${jewlr_t("Cart")}`}
      />
    </div>
  )
}

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    callEmptyCart: () => {
      dispatch(emptyCart())
    },
  }
}

InternalEmptyOutCart.propTypes = {
  callEmptyCart: PropTypes.func,
}

const EmptyOutCart = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalEmptyOutCart)

export default EmptyOutCart
